import { hydrate } from '@propublica/pp-svelte/util/hydrate-rails.mjs';
import * as componentClasses from './svelte-components.js';

document.addEventListener('DOMContentLoaded', () => {
    hydrate(componentClasses);
});
